module.exports = __webpack_public_path__ + "img/golden-card.95956b14.png";